// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lf-0";